import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CollectionManager from './CollectionManager';
import ActivityManager from "./ActivityManager";
import ThemeStatusTypes from "./ThemeStatusTypes";

class CollectionStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.COLLECTIONS_FETCH:
        // noinspection JSIgnoredPromiseFromCall
        CollectionManager.all();
        return this.getInitialState();

      case ActionTypes.COLLECTIONS_FETCH_COMPLETE:
        return action.collections;

      case ActionTypes.COLLECTION_FETCH:
        // noinspection JSIgnoredPromiseFromCall
        CollectionManager.fetch(action.id);
        return this.getInitialState();

      case ActionTypes.COLLECTION_FETCH_COMPLETE:
        return action.collection;

      case ActionTypes.COLLECTION_STORE_INTRO_CHAPTER_ENTER:
        ActivityManager.saveActivityLog({
          params: {
            collection_id: action.collectionId,
            chapter_id: action.chapterId,
            event_type: ThemeStatusTypes.THEME_STATUS_INTRO_CHAPTER_VIEWED
          },
          path: 'collection-intro-activities'
        });
        return state;

      default:
        return state;
    }
  }
}

export default new CollectionStore();
